import { useEffect } from 'react';

import { useRouter } from 'next/router';

import { useNiceModal } from '~/src/common/services/ModalsManager';

const useAccountManagementModal = () => {
  const { show: showAccountManagementModal } = useNiceModal('account-management-modal');
  const { query } = useRouter<{
    login?: boolean;
    signup?: boolean;
  }>();

  useEffect(() => {
    if (query?.login) {
      void showAccountManagementModal();
    }
    if (query?.signup) {
      void showAccountManagementModal({ showSignup: true });
    }
  }, [showAccountManagementModal, query?.login, query?.signup]);
};

export default useAccountManagementModal;
